import { InventoryAssetDetailType } from '@atom/types/inventory';

import CostHeader from './CostHeader';
import UsageTable from './UsageTable';

import classes from './cost.module.css';

interface Props {
  asset: InventoryAssetDetailType;
}

const CostTab = ({ asset }: Props) => {
  return (
    <div className={classes.bodyContainer}>
      <div className={classes.leftBodyPaneFixed} />
      <div className={classes.rightBodyPaneFill}>
        <CostHeader asset={asset} />
        <div className={classes.contentContainer}>
          <UsageTable asset={asset} />
        </div>
      </div>
    </div>
  );
};

export default CostTab;
